"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Realized this is an imperfect function...
// but it's used consistently for figuring out an age in months as decimal

function roundToHundreth(x) {
  var precision = 0.01;
  var y = +x + (precision === undefined ? 0.5 : precision / 2);
  return y - y % (precision === undefined ? 1 : +precision);
}

exports.default = roundToHundreth;